import { Bar } from 'react-chartjs-2'
import { Grid } from '@material-ui/core'

import Card from 'src/components/sharedComponents/Card/Card'
import CardBody from 'src/components/sharedComponents/Card/CardBody'
import CardHeader from 'src/components/sharedComponents/Card/CardHeader'
import * as Utils from 'src/utils/chartsUtils'
import { useStyles } from '../styles'
import TableAA from '../../Tables/TableAA'
import TableAAPP from '../../Tables/TableAAPP'
import TableAAPPMarketShare from '../../Tables/TableAAPPMarketShare'

const TotalResultsCard = props => {
  const {
    totalResults = [],
    selectedDate,
    gTotalResults,
    gATotalResultsSucategory,
    totalResultsSucategory,
    gBTotalResultsSucategory,
    totalResultsRegion,
    gATotalResultsRegion,
    gBTotalResultsRegion,
    table10A,
    table10B,
  } = props
  const classes = useStyles()

  return (
    <>
      <Card>
        <CardHeader>
          <div className={classes.center}>
            <div>
              <h3>Evolución total</h3>
            </div>
            {`  `}
          </div>
        </CardHeader>
        <CardBody>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={12} lg={6}>
              <TableAA array={totalResults} selectedDate={selectedDate} />
            </Grid>
            <Grid item xs={12} sm={12} lg={6}>
              <h3>Evolución del mercado total en miles</h3>
              <br />
              <Bar
                data={Utils.simpleBarLine(gTotalResults, 'Y', 'CANT', 'VARIACION', 'Año')}
                options={Utils.optionsSimpleBarChart}
              />{' '}
            </Grid>
          </Grid>
        </CardBody>
      </Card>
      <Card>
        <CardHeader>
          <div className={classes.center}>
            <div>
              <h3>Auteco Mobility por sub categorías</h3>
            </div>
            {`  `}
          </div>
        </CardHeader>
        <CardBody>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={12} lg={12}>
              <TableAAPP array={totalResultsSucategory} selectedDate={selectedDate} param="SUBCATEGORIA" AA />
            </Grid>
            <Grid item xs={12} sm={12} lg={6}>
              <h3>Participación de mercado en unidades – año</h3>
              <br />
              <Bar data={Utils.barLineDataGroup(gATotalResultsSucategory, 'Y')} options={Utils.optionsGroupedCharts} />
            </Grid>
            <Grid item xs={12} sm={12} lg={6}>
              <h3>Participación de mercado en unidades – mes</h3>
              <br />
              <Bar
                data={Utils.barLineDataGroup(gBTotalResultsSucategory, 'mes')}
                options={Utils.optionsGroupedCharts}
              />
            </Grid>
          </Grid>
        </CardBody>
      </Card>
      <Card>
        <CardHeader>
          <div className={classes.center}>
            <div>
              <h3>Auteco Mobility por region</h3>
            </div>
            {`  `}
          </div>
        </CardHeader>
        <CardBody>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={12} lg={12}>
              <TableAAPP array={totalResultsRegion} selectedDate={selectedDate} param="TERRITORIO" AA />
            </Grid>
            <Grid item xs={12} sm={12} lg={12}>
              <h3>Participación de mercado en unidades – año</h3>
              <br />
              <Bar
                data={Utils.customBarLineDataGroup(gATotalResultsRegion, 'territorio', 'PORCENTAJE', 'y', '100')}
                options={Utils.optionsGroupedCharts}
              />
            </Grid>
            <Grid item xs={12} sm={12} lg={12}>
              <h3>Participación de mercado en unidades – mes</h3>
              <br />
              <Bar
                data={Utils.customBarLineDataGroup(gBTotalResultsRegion, 'TERRITORIO', 'PORCENTAJE', 'MESC', '1')}
                options={Utils.optionsGroupedCharts}
              />
            </Grid>
            <Grid item xs={12} sm={12} lg={12}>
              <h3>Auteco Mobility por zonas</h3>
              <br />
              <TableAAPPMarketShare
                array={table10A}
                param="TERRITORIO"
                selectedDate={selectedDate}
                titleRow="Unidades mes anterior"
              />
              <br />
              <TableAAPPMarketShare
                array={table10B}
                param="TERRITORIO"
                selectedDate={selectedDate}
                titleRow="Unidades Enero - Diciembre"
              />
            </Grid>
          </Grid>
        </CardBody>
      </Card>
    </>
  )
}

export default TotalResultsCard
